import React from 'react';
import { Box } from '@chakra-ui/react';
import { useFlag } from '@unleash/proxy-client-react';

import { ActionTypeV2 } from '../../../../api/types';
import { AppToggle } from '../../../../clients/unleash/app-toggle-names';
import { useAppsV2 } from '../../../../redux/hooks/answer/apps-v2-hook';
import { useDirectAnswer } from '../../../../redux/hooks/answer/direct-answers-hooks';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks/app-hooks';
import { closeDirectAnswerEditModal } from '../../../../redux/slices/modals/direct-answer-edit-modal-slice';
import { setMinimizeSidebarWidthWithAnimation } from '../../../../redux/slices/resize/resize-slice';
import { EditPanel } from '../../../EditPanel/EditPanel';

import styles from './DirectAnswerEditPanel.module.scss';

export interface IFormData {
    answer: string | undefined;
}

export const DirectAnswerEditPanel: React.FC = () => {
    const { updateDirectAnswer: updateAppV1 } = useDirectAnswer();
    const { update: updateAppV2 } = useAppsV2();
    const { content } = useAppSelector((state) => state.modals.editDirectAnswer);
    const shouldSupportAppsV2 = useFlag(AppToggle.APPS_V2);
    const actionType = useAppSelector((state) => state.question.action_type);

    const dispatch = useAppDispatch();

    const handleCloseModal = () => {
        dispatch(closeDirectAnswerEditModal());
        dispatch(setMinimizeSidebarWidthWithAnimation());
    };

    const update = async (content: string) => {
        if (shouldSupportAppsV2 && actionType === ActionTypeV2.CUSTOM) {
            return updateAppV2(content);
        } else {
            return await updateAppV1(content);
        }
    };

    return (
        <Box className={styles.wrapper}>
            <EditPanel onClose={handleCloseModal} onSubmit={update} initialContent={content} />
        </Box>
    );
};
